<template>
  <div class="flex items-center border-b border-gray-700 pt-3 pb-4 transition-all delay-300 duration-300 ease-in-out">
    <div
      v-if="workspace"
      class="flex h-10 w-10 items-center justify-center rounded bg-indigo-500 font-semibold"
      :class="{
        'mx-auto': !displayFull,
        'mx-3': displayFull,
      }">
      <span>{{ workspace?.name?.charAt(0) }}</span>
    </div>
    <div v-if="displayFull" class="flex flex-col">
      <span class="text-base font-semibold">{{ workspace?.name }}</span>
      <span class="text-sm text-gray-400">{{ totalMembers }}</span>
    </div>
  </div>
</template>
<script setup>
import { useWorkspaceStore } from '@/stores/api/workspace';
import { computed } from 'vue';

defineProps({
  displayFull: {
    type: Boolean,
    default: true,
  },
});

const workspaceStore = useWorkspaceStore();

const workspace = computed(() => {
  return workspaceStore.workspaces[0];
});

const totalMembers = computed(() => {
  const totalMembers = workspace.value?.members?.length;
  return totalMembers > 1 ? `${totalMembers} Members` : `${totalMembers} Member`;
});
</script>
